/**
 * ZEN ERP — Minimal Sayfalama Bileşeni
 * Kullanım: <ZenPagination total={filtered.length} page={page} pageSize={pageSize} onPage={setPage} onPageSize={(n)=>{setPageSize(n);setPage(1)}} />
 */
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const PAGE_SIZES = [20, 50, 100, 500];

export default function ZenPagination({ total, page, pageSize, onPage, onPageSize }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  // Sayfa numarası listesi: max 5 görünür, ortada aktif sayfa
  const pages = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) pages.push(i);
  } else {
    pages.push(1);
    if (page > 3) pages.push("...");
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) pages.push("...");
    pages.push(totalPages);
  }

  if (total === 0) return null;

  return (
    <div className="flex items-center justify-between gap-4 py-2 px-1 mt-2 flex-wrap"
      data-testid="zen-pagination">

      {/* Sol: kayıt bilgisi */}
      <span className="text-xs text-slate-500 dark:text-slate-400 shrink-0">
        {from}–{to} / <span className="font-semibold text-slate-700 dark:text-slate-300">{total}</span> kayıt
      </span>

      {/* Orta: sayfa numaraları */}
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPage(Math.max(1, page - 1))}
          disabled={page === 1}
          data-testid="zen-page-prev"
          className="w-7 h-7 rounded flex items-center justify-center text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 disabled:opacity-30 transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>

        {pages.map((p, i) =>
          p === "..." ? (
            <span key={`dot-${i}`} className="w-7 h-7 flex items-center justify-center text-xs text-slate-400">…</span>
          ) : (
            <button
              key={p}
              onClick={() => onPage(p)}
              data-testid={`zen-page-${p}`}
              className={`w-7 h-7 rounded text-xs font-semibold transition-colors ${
                p === page
                  ? "bg-[#E5322A] text-white"
                  : "text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800"
              }`}
            >
              {p}
            </button>
          )
        )}

        <button
          onClick={() => onPage(Math.min(totalPages, page + 1))}
          disabled={page === totalPages}
          data-testid="zen-page-next"
          className="w-7 h-7 rounded flex items-center justify-center text-slate-500 hover:text-slate-800 dark:hover:text-slate-200 disabled:opacity-30 transition-colors"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>

      {/* Sağ: sayfa boyutu */}
      <div className="flex items-center gap-1 shrink-0">
        {PAGE_SIZES.map(s => (
          <button
            key={s}
            onClick={() => onPageSize(s)}
            data-testid={`zen-pagesize-${s}`}
            className={`px-2 py-0.5 rounded text-xs font-semibold transition-colors ${
              s === pageSize
                ? "bg-slate-800 dark:bg-slate-200 text-white dark:text-slate-900"
                : "text-slate-400 hover:text-slate-700 dark:hover:text-slate-300"
            }`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}
